import { useEffect, useRef } from "react";

// 동시에 열린 오버레이 수. 오버레이 전환(닫힘+열림이 같은 커밋)에도
// history 항목이 중복 push/pop 되지 않게 스택 깊이로 관리한다.
let overlayDepth = 0;

/**
 * 모달/드로워가 열려 있을 때 (모바일) 브라우저 뒤로가기로 페이지를 벗어나지 않고
 * 해당 오버레이만 닫는다.
 *
 * - 열릴 때: history 항목이 없으면 하나 push (오버레이 전환 시엔 기존 항목 재사용)
 * - 뒤로가기(popstate): onClose 호출 → 오버레이만 닫힘 (페이지 유지)
 * - UI(X·취소·바깥탭 등)로 닫힘: 마지막 오버레이가 닫힐 때만 항목을 history.back 으로 정리
 *
 * back 여부 판단은 커밋 이후(microtask)로 미뤄 depth 를 다시 확인한다.
 * 전환 중이면(depth>0) back 하지 않아, 옛 오버레이 cleanup 의 back() 이
 * 새 오버레이를 즉시 닫아버리는 레이스를 막는다.
 */
export function useBackButtonClose(open: boolean, onClose: () => void) {
  const closeRef = useRef(onClose);
  useEffect(() => {
    closeRef.current = onClose;
  });

  useEffect(() => {
    if (!open) return;
    overlayDepth += 1;
    if (!window.history.state?.overlay) {
      window.history.pushState({ overlay: true }, "");
    }
    const onPop = () => closeRef.current();
    window.addEventListener("popstate", onPop);
    return () => {
      window.removeEventListener("popstate", onPop);
      overlayDepth -= 1;
      queueMicrotask(() => {
        if (overlayDepth === 0 && window.history.state?.overlay) {
          window.history.back();
        }
      });
    };
  }, [open]);
}
